import { useState } from 'react';
import ProgressLogService, { CHAVES_LOGS } from '../api/ProgressLogService';
import { ProgressLog } from '../types/entities';
import { LogType } from '../types/enums';
import { useCurrentUser } from './useCurrentUser';
import usePagina from './usePagina';
import { formatDate as formatDateBase, formatDuration } from '../utils/date';

/** Data no estilo longo (ex.: 25 de dezembro de 2026). Fonte: utils/date. */
export const formatDate = (value: string | null | undefined): string =>
  formatDateBase(value, 'long');

export { formatDuration };

export default function useRoutineProgress() {
  const { userId } = useCurrentUser();
  const [selected, setSelected] = useState<ProgressLog | null>(null);

  const { itens, total, pagina, totalPaginas, setPagina, query } = usePagina(
    CHAVES_LOGS.lista(userId!, LogType.ROUTINE),
    (page) => ProgressLogService.getLogPage(userId!, LogType.ROUTINE, page),
    Boolean(userId),
  );

  return {
    logs: itens,
    total,
    pagina,
    totalPaginas,
    setPagina,
    loading: query.isLoading,
    error: query.isError ? 'Não foi possível carregar o histórico de rotinas.' : '',
    selected,
    setSelected,
  };
}
